import { create } from 'zustand';

const testStore = create((set, get) => ({
  number: 0,
  setNumber: (number) => {
set({number: number});
  }
}));

export default testStore;